import { Header } from "@/components/ui/headers";
import { Sidebar } from "@/features/sidebar/components/sidebar";
import React from "react";
import { Outlet } from "react-router-dom";

interface MainLayoutProps {
  title?: string;
  onRefresh?: () => void;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ title, onRefresh }) => {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header title={title} onRefresh={onRefresh} />
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
